import { useShop } from '../app/boot.tsx';
import { CustomerTabs } from '../app/nav.tsx';
import { Empty, Page } from '../ui/index.tsx';

export function Info() {
  const { shop } = useShop();
  return (
    <>
      <Page title="ข้อมูลร้าน">
        {(shop.address || shop.phone || shop.mapUrl) && (
          <div className="card" style={{ marginBottom: 4 }}>
            {shop.address && <p style={{ marginBottom: 12 }}>{shop.address}</p>}
            <div className="row" style={{ flexWrap: 'wrap' }}>
              {shop.phone && <a className="btn btn-primary" href={`tel:${shop.phone}`}>โทรหาร้าน</a>}
              {shop.mapUrl && <a className="btn btn-secondary" href={shop.mapUrl} target="_blank" rel="noopener noreferrer">เปิดแผนที่</a>}
            </div>
          </div>
        )}

        <p className="section-title">เวลาเปิดร้าน</p>
        <div className="card">
          <ul className="info-hours">
            {shop.hours.map((h) => {
              const [day, ...rest] = h.split(' ');
              const time = rest.join(' ');
              return (
                <li key={h} className={time === 'ปิด' ? 'muted' : ''}>
                  <span>{day}</span><span>{time}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="section-title">บริการและราคา</p>
        {shop.services.length === 0
          ? <Empty title="ยังไม่มีรายการบริการ" />
          : (
            <div className="list">
              {shop.services.map((s) => (
                <div key={s.id} className="card row-between">
                  <div>
                    <div className="card-title">{s.name}</div>
                    <div className="muted small">{s.durationMin} นาที</div>
                  </div>
                  <span className="price">{s.price.toLocaleString('th-TH')} บาท</span>
                </div>
              ))}
            </div>
          )}
      </Page>
      <CustomerTabs />
    </>
  );
}
